import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectPageType } from '../selectors/page';

const OFFER_CARD_REGEXP = /\/(sale|rent)\/(flat|commercial|suburban)\/\d+/;

export const useIsOfferCardPage = () => {
  const pageType = useSelector(selectPageType);
  const [isOfferCardPage, setIsOfferCardPage] = useState(pageType === 'offerCard');

  /**
   * Этот эффект нужен, чтобы обработать кейс перехода из поиска в карточку
   * Там переход происходит через react-router, поэтому шапка не перерисовывается и нужно отслеживать специальное событие
   */
  useEffect(() => {
    const handlePageChanged = () => {
      setIsOfferCardPage(
        (pageType === 'search' || pageType === 'offerCard') && OFFER_CARD_REGEXP.test(window.location.href),
      );
    };

    const handleOfferCardClick = () => {
      setIsOfferCardPage(true);
    };

    // Обрабатываем переходы "Вперед" и "Назад"
    addEventListener('popstate', handlePageChanged);
    // Обрабатываем клики на карточку объявления через react-router
    addEventListener('clickOfferCard', handleOfferCardClick);

    return () => {
      removeEventListener('popstate', handlePageChanged);
      removeEventListener('clickOfferCard', handleOfferCardClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isOfferCardPage;
};
